/** State kept for the legacy iframe bridge. */
export interface LegacyState {
    /** Whether the legacy iframe is currently loading. */
    iframeLoading: boolean;
}

/** Initial state for the legacy iframe bridge. */
export const initialLegacyState: LegacyState = {
    iframeLoading: true,
};
